<template>
  <div id="header">
    <div class="mHeader">
      <img class="mHeaderLeft" src="../../assets/img/mLeft.png" @click="goIndex">
      <b>亳药师</b>
      <img class="mHeaderMenu" v-show="showHeaderIcon" src="../../assets/img/mIndexMenu.png" @click="showMenu">
      <img class="mHeaderUser" v-show="showHeaderIcon" src="../../assets/img/mUser.png"  @click="goLogin">
      <img class="mHeaderClose" v-show="showHeaderIcon2" src="../../assets/img/mIndexClose.png" @click="closeMenu" >
      <!-- <a v-show="showLogin" @click="goLogin">请登录</a>&nbsp;&nbsp;<a  v-show="showLogin" @click="goRegister">免费注册</a> -->
    </div>
    <div class="mMenu" v-show="showMenuDiv">
      <ul>
        <li v-for="(item,menuIndex) in menuList" :class="menuActiveClass == menuIndex ? 'menuActive':''" :key="item.name"  @click="goMenu(item.go,menuIndex)">{{item.name}}</li>
      </ul>
    </div>
    <Login ref="login"></Login>
    <Register ref="register"></Register>
  </div>
</template>
<script>
import Login from '../mobile/mLogin'
import Register from '../mobile/mRegister'
export default {
  components: {
    Login,
    Register,
  },
  data() {
    return {
      showHeaderIcon:true,
      showHeaderIcon2:false,
      showMenuDiv:false,
      activeClass: -1, 	// 0为默认选择第一个，-1为不选择
      menuActiveClass:0,
      jgActiveClass:0,
      zfActiveClass:0,
      tdIndex:0,
      zfTdIndex:0,
      menuList:[
        {go:'mIndex',name:'首页'},
        {go:"mClassList",name:'产品分类'},
        {go:'mOfferList',name:'推荐资源'},
        {go:'mDynamicsList',name:'交易动态'},
        {go:'mNewsList',name:'新闻资讯'},
        {go:'mProductList',name:'自营产品'}
      ],
      showLogin:true,
      showAfterLogin:false,
    }
  },
  computed:{
    defaultOption () {
      return {
        step: 0.1, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null || this.$cookie.get('account') == ''){
      this.showLogin = true
      this.showAfterLogin = false
    }else{
      this.showLogin = false
      this.showAfterLogin = true
    }
    if(this.$cookie.get('menuA') != null){
      this.menuActiveClass = this.$cookie.get('menuA')
    }
  },
  methods: {
    showMenu(){
      this.showMenuDiv = true;
      document.body.style['overflow'] = 'hidden';
      this.showHeaderIcon = false;
      this.showHeaderIcon2 = true;
    },
    closeMenu(){
      this.showMenuDiv = false;
      document.body.style['overflow-y'] = 'scroll';
      this.showHeaderIcon = true;
      this.showHeaderIcon2 = false;
    },
    goMenu(go,index){
      this.$cookie.set('menuA',index)
      this.menuActiveClass = index;
      document.body.style['overflow'] = 'auto';
      this.$router.push(go)
    },
    goLogin(){
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
    },
    goIndex(){
      this.$router.push({name:'mIndex'})
    }
  }
}
</script>
<style>
  @import "../../assets/css/mStyle.css";
</style>



// WEBPACK FOOTER //
// src/components/mobile/mHeader.vue